import { MessageBox } from 'element-ui'
import axios from 'axios'
import { CHECK_APP_UPDATE_POLLING_INTERVAL } from './const'

export default class AppUpdateReminder {
  constructor() {
    this.pollingTimeInterval = CHECK_APP_UPDATE_POLLING_INTERVAL
    this.isShowingPopup = false
    this.timer = null
    this.previousHTML = null
    this.startCheckUpdatePolling()
  }

  startCheckUpdatePolling() {
    this.checkAppHasUpdate()

    this.timer = setInterval(() => {
      this.checkAppHasUpdate()
    }, this.pollingTimeInterval)
  }

  async checkAppHasUpdate() {
    try {
      const response = await axios.get(process.env.BASE_URL)
      if (response.status !== 200) {
        throw new Error('abort')
      }
      const pageHTML = response.data

      // Get the first snapshot of index.html when the app first mounted.
      if (!this.previousHTML) {
        this.previousHTML = pageHTML
        return
      }

      // If the current snapshot is different than the old snapshot, ask for reload.
      if (this.previousHTML !== pageHTML) {
        this.previousHTML = pageHTML
        if (!this.isShowingPopup) {
          this.showShouldRefreshPagePopup()
        }
      }
    } catch (error) {
      // Not handling
    }
  }

  async showShouldRefreshPagePopup() {
    this.isShowingPopup = true
    try {
      await MessageBox.confirm('Do you wish to reload the page now to get the latest updates? Make sure you don\'t have any unsaved work!', 'New App Version', {
        confirmButtonText: 'Reload',
        cancelButtonText: 'Cancel',
        type: 'info',
      })

      window.location.reload()
    } catch (error) {
      console.log(error)
    } finally {
      this.isShowingPopup = false
    }
  }
}
